module.exports = __webpack_public_path__ + "static/media/mgo45ws.a967f2ec.pdf";